export default "__VITE_ASSET__BuislAcZ__"